<template>
    <div class="bg_eef1fa audit web_detail">
        <div class="main bg_fff">
            <h2>音频详情</h2>
            <!--<div class="audit_info flex_start align_items_flex_start">
                <div class="audit_list_operate flex_start">
                    <img src="@/assets/images/ic_head.png" @click="likeBtn(detail.id)" v-if="is_like == 0" />
                    <img src="@/assets/images/header_red.png" @click="likeBtn(detail.id)" v-else />
                </div>
                <img :src="detail.pic" />
                <div class="audit_info_text">
                    <div class="audit_info_text_title flex_start align_items_center">
                        <label>{{detail.title}}</label>
                        <div class="headset flex_start align_items_center"><img src="@/assets/images/ic_headset.png" />32323</div>
                    </div>
                    <div class="audit_info_text_info">{{detail.intro}}</div>
                    <p class="flex_start flag_list flex_wrap">
                        <span v-for="(item,index) in detail.flag">{{item}}</span>
                    </p>
                </div>
            </div>-->

            <div class="audit_list flex_start align_items_center flex_wrap">
                <div class="audit_list_operate flex_start">
<!--                    <img src="@/assets/images/ic_share_2.png" />-->
                    <img src="@/assets/images/ic_head.png" @click="likeBtn(detail.id)" v-if="is_like == 0" />
                    <img src="@/assets/images/header_red.png" @click="likeBtn(detail.id)" v-else />
                    <img src="@/assets/images/ic_share_2.png" @click="copyText(detail.id)" />
                    <img src="@/assets/images/ic_download.png" @click="downloadBtn(detail.id)" />
                </div>
                <div class="audit_list_img">
                    <img :src="detail.pic" />
                </div>
                <div class="audit_list_box flex_start flex_wrap">
                    <div class="audit_list_info">
                        <h4>{{detail.title}}</h4>
                        <h5>{{detail.intro}}</h5>
                    </div>
                    <div class="audit_main">
                        <audio :src="detail.annex" controls="controls"></audio>
                    </div>
                </div>
                <div class="audit_list_flag">
                    <p class="flex_start flag_list flex_wrap">
                        <span v-for="(item,index) in detail.flag">{{item}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "detail",
        data(){
            return {
                id: 0,
                detail:[],
                likelist: [],
                is_like:0,
                is_good:0
            }
        },

        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/article',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{type:'audit',id:this.id,token: localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data.detail;
                    this.is_like = res.data.data.is_like;
                    this.is_good = res.data.data.is_good;
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        mounted() {
        },
        methods: {
        // 文本复制
        copyText () {
            //使用textarea的原因是能进行换行，input不支持换行
            var copyTextArea = document.createElement("textarea");
            //自定义复制内容拼接
            var str = window.location.href;
            copyTextArea.value = str;
            document.body.appendChild(copyTextArea);
            copyTextArea.select();
            var copyed = document.execCommand("copy");
            if (copyed) {
                document.body.removeChild(copyTextArea);
                //这里是封装的提示框，可以换成自己使用的提示框
                layer.msg('复制成功');
            }
        },
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            },
            likeBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/likeBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        _this.is_like = _this.is_like == 1 ? 0 : 1;
                    }
                    layer.msg(res.data.msg);
                });
            },
            downloadBtn: function (id) {
                let _this = this;

                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/downloadBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        let a = $("<a href='" + _this.detail.annex + "' target='_blank' download></a>").get(0);
                        let e = document.createEvent('MouseEvents');
                        e.initEvent('click', true, true);
                        a.dispatchEvent(e);
                    }else {
                        layer.msg(res.data.msg);
                    }
                });
            },
            funDown: function(row){
                var that = this;
                that.$http({
                    url: 'my/downGeneral',
                    method: 'post',
                    data:{filename:row,token: localStorage.getItem('user_token')},
                }).then(res => {
                    let aLink = document.createElement('a');
                    let blob = this.base64ToBlob(res.data.data); //new Blob([content]);
                    let evt = document.createEvent("HTMLEvents");
                    console.log("点击下载",evt)
                    evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                    aLink.download = res.data.companyname;
                    aLink.href = URL.createObjectURL(blob);

                    aLink.click()
                });
            },
            base64ToBlob(code) {
                let parts = code.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;
                let uInt8Array = new Uint8Array(rawLength);
                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: contentType});
            },
        }
    }
</script>

<style scoped>
    .audit{padding:45px 0 80px;}
    .audit .main{padding:85px 20px 145px;}
    .audit h2{width: 100%;font-size:44px;line-height: 45px;color:#333;font-weight: normal;display: block;margin-bottom: 65px;}

    .audit_info{width:100%;padding:20px 28px 28px;box-shadow: 0 0 20px rgba(170,176,194,.3);position: relative;border-radius: 5px;}
    .audit_info img{width: 200px;height: 200px;margin-right: 38px;object-fit: cover;display: block;}
    .audit_info_text{width: calc(100% - 250px);display: block;}
    .audit_info_text_title{width:100%;font-size: 32px;line-height: 72px;color:#333;font-weight: normal;}
    .headset{font-size:20px;color:#333;margin-left:115px;height: 20px;}
    .headset img{width: 18px;object-fit: contain;display: block;margin-right: 6px;}
    .audit_info_text_info{width:100%;font-size: 20px;line-height: 36px;color:#333;display: block;height: 72px;margin-bottom: 20px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}

    .flag_list{width: 100%;}
    .flag_list span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 3px;}

    .audit_list{width:100%;padding:16px 28px;border-radius: 5px;position: relative;background: #fff;box-shadow: 0 0 20px rgba(170,176,194,.3);margin-top:37px;}
    .audit_list_img{width: 71px;height: 70px;border-radius: 5px;min-width: 71px;display: block;margin-right: 16px;overflow: hidden;}
    .audit_list_img img{width: 100%;height: 100%;object-fit: cover;display: block;}
    .audit_list_info{width: 200px;display: block;margin-right: 70px;}
    .audit_list_info h4,.audit_list_info h5{width:100%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;font-weight: normal;color:#333;}
    .audit_list_info h4{font-size: 20px;line-height: 30px;}
    .audit_list_info h5{font-size: 14px;line-height: 20px;}
    .audit_list_flag{width:100%;display: block;margin-top:18px;}
    .audit_main{width:540px;height: 43px;display: block;}
    .audit_main audio{width: 100%;height: 100%;display: block;}

    .audit_list_operate{width:117px;height: 34px;position: absolute;top:-13px;right:20px;background: #f5f5f5;z-index:2;}
    .audit_list_operate img{width:39px;height: 20px;object-fit: contain;display: block;margin:7px auto;}
    .audit_info .audit_list_operate{width: 66px;height: 48px;top:-27px;}
    .audit_info .audit_list_operate img{width: 66px;height: 20px;object-fit: contain;display: block;margin:12px auto;}

    @media screen and (max-width: 1240px) {
        .web_detail{width: 100%;padding:3.629vw 2% 6.4516vw;}
        .web_detail.audit .main{padding:6.8548vw 1.6129vw 11.6935vw;}
        .web_detail.audit h2{font-size:3.5483vw;line-height: 3.55vw;margin-bottom: 5.2419vw;}
        .audit_info{padding:2vw;}
        .audit_list_box{width:calc(100% - 90px);}
        .audit_list_info{width: 100%;margin-right: 2vw;}
        .audit_main{width: 100%;max-width: 43.548vw;height: 30px;margin-top:5px;}
        .audit_list{padding:2vw 2%;}
    }
    @media screen and (max-width: 750px) {
        .web_detail.audit h2{font-size:28px;line-height: 28px;margin-bottom:55px;}
        .web_detail .audit_info img{width:26.666vw;height: 26.666vw;margin-right: 5.066vw;}
        .web_detail .audit_info .headset img{width: 2.4vw;height: auto;margin-right: 0.8vw;}
        .audit_info .audit_list_operate{width: 8.8vw;height: 6.4vw;top:-3.6vw;}
        .audit_list_operate{width: 15.6vw;height: 6.4vw;}
        .web_detail .audit_info .audit_list_operate img,.audit_list_operate img{width:  8.8vw;height: 2.666vw;margin:1.867vw auto;}
        .web_detail .audit_info_text{width: calc(100% - 31.732vw);}
        .audit_info_text_title{font-size:4.266vw;line-height: 9.6vw;}
        .web_detail .headset{margin-left:2vw;font-size:2.666vw;height: 2.666vw;}
        .web_detail .audit_info_text_info{height: auto;}
        .web_detail .flag_list span{border-radius: 5px;margin-right: 1vw;}

    }
    @media screen and (max-width: 750px) {
        .audit_main{max-width: 100%;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/audit/detail.vue